import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import BondsTile from '@/creditflowresearch/ui/components/bonds/BondsTile';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import TileFallback from '@/creditflowresearch/ui/components/bonds/BondsTile/TileFallback';
import { useModuleVisibility } from '@/creditflowresearch/application/ModuleVisibility';
import { BONDS_TILE_HEADER_MAPPING_NAME } from '@/creditflowresearch/application/Bonds/constants';

interface IBondsTileWithFallbackProps {
  userAccessChecks: boolean[],
}

const BondsTileWithFallback = ({ userAccessChecks }: IBondsTileWithFallbackProps) => {
  const { checkAccessByUserPlan, plan } = useUserPlanContext();
  const isModuleVisible = useModuleVisibility(BONDS_TILE_HEADER_MAPPING_NAME);

  if (!isModuleVisible) return null;

  const checks = [
    ...userAccessChecks,
    checkAccessByUserPlan(UserPlanType.PRO),
  ];

  return (
    <CheckUserAccess
      conditions={ [
        {
          checks: [!UserPlan.isUnauthorized(plan)],
          fallback: <TileFallback />,
        },
        {
          checks,
          fallback: <TileFallback isAuthorized />,
        },
      ] }
    >
      <BondsTile />
    </CheckUserAccess>
  );
};

export default BondsTileWithFallback;
